import Option from '@/modules/common/models/option/option.ts';

export default class RouteOption extends Option<number> {
  constructor(response: any) {
    super(response, 'DOC_ID', 'Содержание');
  }
}
